<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>统计报表</el-breadcrumb-item>
			<el-breadcrumb-item>{{ activeLabel }}</el-breadcrumb-item>
		</el-breadcrumb>
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane label="设备统计" name="jt">
				<JtReport></JtReport>
			</el-tab-pane>
			<el-tab-pane label="工单统计" name="second">工单统计</el-tab-pane>
			<el-tab-pane label="人员统计" name="third">人员统计</el-tab-pane>
			<el-tab-pane label="工艺统计" name="fourth">工艺统计</el-tab-pane>
			<el-tab-pane label="车间统计" name="fourth">车间统计</el-tab-pane>
			<el-tab-pane label="班次统计" name="fourth">班次统计</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	import JtReport from './JtReport'
	export default {
		components: {
			JtReport,
		},
		data() {
			return {
				showDeviceInfo: false,
				selectedJT: {},
				activeName: '',
				activeLabel: '',
			}
		},
		methods: {
			handleClick(tab, event) {
				console.log(tab)
				this.activeLabel = tab.label
				this.activeName = tab.name
			},
			/**
			 * 查看机台状态。
			 */
			handleSelectJT(jt) {
				this.showDeviceInfo = true
				this.selectedJT = jt
			},
		},
		created() {},
	}
</script>

<style scoped></style>
